<template>
  <div>
    <div class="text-subtitle-2 mb-3">Suscripción</div>
    <v-row>
      <v-col cols="12" md="6">
        <v-select
          v-model="local.planId"
          :items="planItems"
          item-text="label"
          item-value="id"
          label="Plan *"
          :rules="[v => !!v || 'Requerido']"
          outlined
          dense
          @change="onPlanChange"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="local.status"
          :items="statusOptions"
          label="Estado"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="local.currentPeriodStart"
          label="Inicio del periodo"
          type="date"
          outlined
          dense
          @change="recalculateEndDate"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="local.currentPeriodEnd"
          label="Fin del periodo *"
          type="date"
          :rules="[v => !!v || 'Requerido']"
          outlined
          dense
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { fetchSubscriptionPlans } from '@/services/platform/subscriptionService';

const STATUS_OPTIONS = [
  { text: 'Activa', value: 'active' },
  { text: 'Prueba', value: 'trialing' },
  { text: 'Pago pendiente', value: 'past_due' },
  { text: 'Cancelada', value: 'canceled' },
  { text: 'Expirada', value: 'expired' },
];

const formatDateInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
};

const addInterval = (startDate, billingInterval) => {
  const end = new Date(startDate);
  if (billingInterval === 'month') {
    end.setMonth(end.getMonth() + 1);
  } else {
    end.setFullYear(end.getFullYear() + 1);
  }
  return formatDateInput(end);
};

const buildDefaultLocal = () => ({
  planId: '',
  status: 'active',
  currentPeriodStart: formatDateInput(new Date()),
  currentPeriodEnd: '',
  externalProvider: 'manual',
});

export default {
  name: 'SubscriptionFields',
  data() {
    return {
      plans: [],
      statusOptions: STATUS_OPTIONS,
      local: buildDefaultLocal(),
    };
  },
  computed: {
    planItems() {
      return this.plans.map((plan) => ({
        ...plan,
        label: `${plan.name} — $${plan.price} ${plan.currency}/${plan.billingInterval === 'year' ? 'año' : 'mes'}`,
      }));
    },
  },
  async created() {
    await this.loadPlans();
    this.applyDefaults();
  },
  methods: {
    async loadPlans() {
      this.plans = await fetchSubscriptionPlans();
    },
    applyDefaults() {
      if (!this.local.planId && this.plans.length) {
        this.local.planId = this.plans[0].id;
        this.recalculateEndDate();
      }
    },
    initFromValues(values = {}) {
      this.local = {
        ...buildDefaultLocal(),
        planId: values.planId || '',
        status: values.status || 'active',
        currentPeriodStart: formatDateInput(values.currentPeriodStart) || formatDateInput(new Date()),
        currentPeriodEnd: formatDateInput(values.currentPeriodEnd) || '',
        externalProvider: values.externalProvider || 'manual',
      };
      this.applyDefaults();
    },
    onPlanChange() {
      this.recalculateEndDate();
    },
    recalculateEndDate() {
      const plan = this.plans.find((item) => item.id === this.local.planId);
      if (!plan || !this.local.currentPeriodStart) return;
      this.local.currentPeriodEnd = addInterval(this.local.currentPeriodStart, plan.billingInterval);
    },
    getPayload() {
      return {
        planId: this.local.planId,
        status: this.local.status,
        currentPeriodStart: this.local.currentPeriodStart,
        currentPeriodEnd: this.local.currentPeriodEnd,
        externalProvider: this.local.externalProvider,
      };
    },
  },
};
</script>
